import { useCallback } from 'react';

const cloneObject = object => {
    const proto = Object.getPrototypeOf(object);
    return Object.setPrototypeOf({ ...object }, proto);
};

const useSetStateImmutable = setState => {
    return useCallback(
        updatedState => {
            switch (true) {
                case Array.isArray(updatedState):
                    setState([...updatedState]);
                    break;
                case updatedState !== null && typeof updatedState === 'object':
                    setState(cloneObject(updatedState));
                    break;
                default:
                    setState(updatedState);
            }
        },
        [setState]
    );
};

export default useSetStateImmutable;
